'use client';

import { c as _c } from "react/compiler-runtime";
import { useHomepageGreeting } from './homepage-greeting.logic.ts';
const flagStyle = {
  fontSize: '16px',
  lineHeight: '16px'
} as const;
export const HomepageGreeting = () => {
  const $ = _c(12);
  const {
    name,
    selectedLanguage,
    subtitle
  } = useHomepageGreeting();
  let t0;
  if ($[0] !== selectedLanguage.flag || $[1] !== selectedLanguage.name) {
    t0 = <span className="relative" aria-hidden="true"><span className="absolute -top-3 left-1/2 -translate-x-1/2 leading-none pointer-events-none inline-block w-4 h-4 text-center" style={flagStyle} role="img" aria-label={selectedLanguage.name}>{selectedLanguage.flag}</span>{","}</span>;
    $[0] = selectedLanguage.flag;
    $[1] = selectedLanguage.name;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = name ? ` ${name}!` : "!";
  let t2;
  if ($[3] !== selectedLanguage.greeting || $[4] !== t0 || $[5] !== t1) {
    t2 = <h1 className="heading-sm heading-neutral-amplified md:heading-md">{selectedLanguage.greeting}{t0}{t1}</h1>;
    $[3] = selectedLanguage.greeting;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== subtitle) {
    t3 = <p className="body-sm body-neutral-mild">{subtitle}</p>;
    $[7] = subtitle;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="HomepageGreeting flex flex-col gap-snug-md w-full py-comfy-sm">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};